import { format } from 'date-fns';
import type { CellProps } from 'react-table';

type GenericCreatedOnItem = {
  createdOn: Date;
};

export default function CreatedOn({ row: { original: data } }: CellProps<GenericCreatedOnItem>) {
  return format(data.createdOn, 'MM/dd/yyyy');
}

export { CreatedOn };